import { VStack, Text } from "native-base";
import { COLORS } from "../../utils/colors";
import Svg from "react-native-svg";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";

const QuickLinksCards = ({ text = "", svg = "" }) => {
  return (
    <VStack flex={1} p={4} ml={2} justifyContent={"center"}>
      <Svg width="37" height="37" viewBox="0 0 37 37">
        {svg}
      </Svg>
      <Text
        fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
        fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
        color={COLORS.PARTNERS_HEADING_COLOR}
      >
        {text}
      </Text>
    </VStack>
  );
};

export default QuickLinksCards;
